import styled, { css } from 'styled-components';

export const HeroDropzoneStyled = styled.div<{ $isDragging: boolean }>`
  align-items: center;
  background-color: #fafafa;
  border: 1px dashed #cccccc;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 200px;
  overflow: hidden;
  padding: 15px;
  text-align: center;

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      background-color: #f0f7f5;
      border-color: #30b48d;
    `}
`;

// Bootstrap sets `input[type="file"] { display: block }`, which outranks a bare
// styled-components class, so the rule has to be nested to win on specificity.
export const HeroFieldStyled = styled.div`
  flex-grow: 1;

  input[type='file'] {
    display: none;
  }
`;

// Mirrors GenericFormField's InputGroupTooltipWrapper, which only flexes a child
// carrying the .input-group class.
export const HeroFieldRowStyled = styled.div`
  display: flex;

  & > .tooltip-container {
    margin-left: 15px;
  }
`;

export const HeroPlaceholderStyled = styled.div`
  color: #999999;

  svg {
    display: block;
    margin: 0 auto 10px;
  }
`;

export const HeroPreviewStyled = styled.img`
  max-height: 200px;
  max-width: 100%;
  object-fit: cover;
`;

export const HeroUploadButtonWrapper = styled.div`
  margin-top: 10px;

  button svg {
    margin-bottom: -2px;
    margin-right: 10px;
  }
`;
